// TODO: Check permissions inside of the route config, and simply don't bind routes that shouldn't be available.
//  We'll still need of a separate awy to check permissions, as we might need to hide some elements on certain pages.
export const PRODUCT_TEMPLATE_CRUD = 'catalog:producttemplate:crud'
export const PRODUCT_READ = 'catalog:product:read'
export const PRODUCT_EDIT = 'catalog:product:edit'
export const PRODUCT_DELETE = 'catalog:product:delete'
export const CATALOG_CRUD = 'catalog:catalog:crud'
export const PRODUCTCATALOG_READ = 'catalog:productcatalog:read'
export const CATEGORY_CRUD = 'catalog:category:crud'
export const USER_READ = 'catalog:user:read'
export const RBAC_CRUD = 'catalog:rbac:crud'
export const MACRO_CRUD = 'catalog:macro:crud'
export const PRODUCT_WIZARD_BULK = 'catalog:bulk:product-view'
export const ORDER_READ = 'orders:productcatalog:read'
export const ORDER_VIEW_ALL = 'orders:order:view-all-orders'
export const ORDER_CANCEL_ALL = 'orders:order:cancel-all'
export const ORDER_OPTIONS_READ = 'reporting:order-options:read'
export const ORDERS_VIEW_ALL_NON_RESTICTED_ORDERS =
    'orders:order:view-all-non-restricted-orders'
export const ORDER_OPTIONS_WRITE = 'reporting:order-options:write'

export function isAllowed(context, permission) {
    const { permissions } = context
    return permissions.indexOf(permission) !== -1
}

export function isAnyAllowed(context, permissions) {
    return permissions.some(
        permission => context.permissions.indexOf(permission) !== -1
    )
}

export function catalogReadIsAllowed(context) {
    return isAnyAllowed(context, [
        PRODUCT_READ,
        PRODUCT_EDIT,
        CATALOG_CRUD,
        PRODUCTCATALOG_READ,
    ])
}

export function productReadIsAllowed(context) {
    return isAnyAllowed(context, [
        PRODUCTCATALOG_READ,
        PRODUCT_EDIT,
        PRODUCT_READ,
    ])
}

export function isGlobalAdmin(context) {
    return context.data.is_global_admin
}
